import { render } from "./property-school.vue?vue&type=template&id=feba93b2"
import script from "./property-school.js?vue&type=script&lang=js"
export * from "./property-school.js?vue&type=script&lang=js"

import "./property-school.vue?vue&type=style&index=0&id=feba93b2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__